import {Type} from '@angular/core';
import {ProjectStepComponentInterface} from './project-base-step/project-base-step.component';
import {ProjectChapterType, ProjectStepType} from '@frontend/shared';

export enum StepStatus {
  NOT_STARTED = 'not-started',
  IN_PROGRESS = 'in-progress',
  COMPLETED = 'completed',
}

export function mapBackendStatusToFrontend(backendStatus: string): StepStatus {
  return StepStatus[backendStatus as keyof typeof StepStatus] ?? StepStatus.NOT_STARTED;
}

export interface Step {
  configId: ProjectStepType;
  stepUiNumber: number;
  status: StepStatus;
  content: Type<ProjectStepComponentInterface>;
  directusId?: string;
  translatedTitle?: string;
  parentChapterConfigId: ProjectChapterType;
}

export interface Chapter {
  configId: ProjectChapterType;
  directusId?: string;
  chapterUiNumber: number; // number that appears in UI, not necessarily the same as in chapterConfig / id
  backgroundImage?: string;
  icon: string;
  expanded: boolean;
  steps: Step[];
  translatedTitle?: string;
}
